var render = function render(){var _vm=this,_c=_vm._self._c;return _c('avue-crud',{ref:"crud",attrs:{"option":_vm.option,"data":_vm.data,"page":_vm.page,"upload-before":_vm.uploadBefore},on:{"refresh-change":_vm.refreshChange,"search-change":_vm.searchChange,"row-save":_vm.store,"row-update":_vm.update,"row-del":_vm.del,"size-change":_vm.sizeChange,"current-change":_vm.currentChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }